<template>
  <v-row>
    <v-col cols="12" md="12" class="d-flex align-center">
      <v-data-table
        show-expand
        v-model="selected"
        @input="handleSelection"
        @toggle-select-all="handleSelectAll"
        :headers="headers"
        :items="desserts"
        :options.sync="options"
        :server-items-length="totalDesserts"
        :loading="loading"
        class="elevation-1"
        loading-text="Loading... Please wait"
        @click:row="openOrderPage"
        height="250"
        fix-header
        :show-select="checkboxEnable"
        :footer-props="{
          'items-per-page-options': [
            10,
            20,
            30,
            40,
            50,
            100,
            250,
            500,
            1000,
            10000
          ]
        }"
        :items-per-page="30"
      >
        <template #item.data-table-expand="{ item, expand, isExpanded }">
          <td v-if="expandTable != null" class="text-start">
            <v-btn
              icon
              @click="expand(!isExpanded)"
              class="v-data-table__expand-icon"
              :class="{ 'v-data-table__expand-icon--active': isExpanded }"
            >
              <v-icon>mdi-chevron-down</v-icon>
            </v-btn>
          </td>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td v-if="item.users" :colspan="headers.length">
            <v-chip v-if="item.users.length > 0">
              <v-chip v-for="(user, index) in item.users" :key="user.id">
                {{ user.username }}
                <v-icon
                  @click="removeUserFromOrder(user, item, index)"
                  dark
                  style="cursor:pointer; color: black;"
                  >delete</v-icon
                >
              </v-chip>
            </v-chip>
            <v-chip v-else>
              No user has been assigned to this order yet.
            </v-chip>
          </td>
        </template>
        <template v-slot:top v-if="exportURL" style="text-align: right;">
          <v-chip
            class="ma-2"
            color="primary"
            label
            @click="exportCSV"
            v-if="isVisible"
          >
            <v-icon left>cloud_download</v-icon>
            Export
          </v-chip>
          <v-chip>
            <v-text-field
              v-model="searchKey"
              label="Search Client Ref"
              @keydown="search"
            ></v-text-field>
          </v-chip>
        </template>
        <template v-slot:item.universal_rts_number="{ item }">
          <router-link :to="{ name: 'order', params: { uid: item.id } }">
            <v-chip> #{{ item.universal_rts_number }} </v-chip>
          </router-link>
        </template>
        <template v-slot:item.is_superuser="{ item }">
          <v-chip v-if="item.is_superuser === true">
            Yes
          </v-chip>
          <v-chip v-else>
            No
          </v-chip>
        </template>
        <template v-slot:item.groups="{ item }">
          <v-chip v-if="item.groups.length >= 1">
            {{
              item.groups[0].name
                .split("_")
                .join(" ")
                .toUpperCase()
            }}
          </v-chip>
          <v-chip v-else>
            --
          </v-chip>
        </template>
        <template v-slot:item.address="{ item }">
          <v-chip>{{ item.address | formatAddress }}</v-chip>
        </template>
        <template v-slot:item.created_on="{ item }">
          <v-chip>{{ item.created_on | formatDate }}</v-chip>
        </template>
        <template v-slot:item.due_on="{ item }">
          <v-chip>{{ item.due_on | formatDate }}</v-chip>
        </template>
        <template v-slot:item.status.name="{ item }">
          <v-chip>{{ item.status.name }}</v-chip>
        </template>
        <template v-slot:item.product.name="{ item }">
          <v-chip>{{ item.product.name }}</v-chip>
        </template>
        <template v-slot:item.address.county="{ item }">
          <v-chip v-if="item.address.county">{{
            item.address.county.name
          }}</v-chip>
          <v-chip v-else></v-chip>
        </template>
        <template v-slot:item.first_borrower="{ item }">
          <v-chip>{{ item.first_borrower }}</v-chip>
        </template>
        <template v-slot:item.on_hold="{ item }">
          <v-chip v-if="item.product.on_hold">YES</v-chip>
          <v-chip v-else>No</v-chip>
        </template>
        <template v-slot:item.vendor="{ item }">
          <v-chip v-if="item.vendor">{{ item.vendor.company_name }}</v-chip>
          <v-chip v-else>{{ item.vendor }}</v-chip>
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
import JwtService from '@/common/jwt.service'
import {
  GETORDERLISTBYCLIENTREF_V2,
  REMOVEUSERFROMORDER
} from '@/store/actions.type'
import API_URL from '@/common/config'
export default {
  name: 'dataTable',
  data () {
    return {
      totalDesserts: 0,
      desserts: [],
      loading: true,
      options: {},
      searchKey: null,
      baseAPIUrl: API_URL,
      isVisible: false,
      selected: null
      // headers: [
      //   {
      //     text: 'Dessert (100g serving)',
      //     align: 'start',
      //     sortable: false,
      //     value: 'name'
      //   },
      //   { text: 'Calories', value: 'calories' },
      //   { text: 'Fat (g)', value: 'fat' },
      //   { text: 'Carbs (g)', value: 'carbs' },
      //   { text: 'Protein (g)', value: 'protein' },
      //   { text: 'Iron (%)', value: 'iron' }
      // ],
    }
  },
  props: {
    dataTableData: {
      count: 0,
      next: null,
      previous: null,
      results: []
    },
    headers: null,
    exportURL: null,
    checkboxEnable: null,
    expandTable: null
  },
  watch: {
    dataTableData: {
      immediate: true,
      handler (newVal, oldVal) {
        this.getDataFromApi().then((data) => {
          this.desserts = data.results
          this.totalDesserts = data.count
        })
      }
    },
    options: {
      handler () {
        this.loading = true
        this.$emit('pageChanged', this.options)
      },
      deep: true
    }
  },
  mounted () {
    this.isVisible = JwtService.checkDownload()
    this.getDataFromApi().then((data) => {
      this.desserts = data.results
      this.totalDesserts = data.count
    })
  },
  methods: {
    removeUserFromOrder (user, order, index) {
      console.log(user.id, order.id, index)
      this.loading = true
      this.ploading = true
      let payload = {
        order: order.id,
        user: user.id
      }
      this.$store.dispatch(REMOVEUSERFROMORDER, payload).then((response) => {
        order.users.splice(index, 1)
        this.loading = false
        this.ploading = false
        alert('Users Removed from Orders')
      })
    },
    handleSelection (event) {
      this.$emit('selectionChanged', { all: false, selected: this.selected })
    },
    handleSelectAll (event) {
      this.$emit('selectionChanged', { all: true, selected: this.selected })
    },
    search (event) {
      if (event.key === 'Enter') {
        if (this.searchKey) {
          this.loading = true
          let orderPayload = {
            client_reference: this.searchKey
          }
          this.$store
            .dispatch(GETORDERLISTBYCLIENTREF_V2, orderPayload)
            .then((response) => {
              this.orderList = response.results
              this.dataTableData = response
              this.exportURL = `${this.baseAPIUrl.BASE_API_URL}/download_orders/?client_reference__contains=${orderPayload.client_reference}`
              this.loading = false
            })
        } else {
          this.$emit('pageChanged', this.options)
        }
      }
    },
    exportCSV () {
      this.loading = true
      var form = document.createElement('form')
      form.method = 'POST'
      form.action = this.exportURL
      var paramString = this.exportURL.split('?')[1]
      var paramArray = paramString.split('&')
      paramArray.forEach((element) => {
        var input = document.createElement('input')
        input.value = element.split('=')[1]
        input.name = element.split('=')[0]
        form.appendChild(input)
      })
      document.body.appendChild(form)
      form.submit()
      this.loading = false
      form.remove()
    },
    getDataFromApi () {
      this.loading = true
      return new Promise((resolve, reject) => {
        const { sortBy, sortDesc, page, itemsPerPage } = this.options
        // console.log(page)
        console.log(sortBy, sortDesc, page, itemsPerPage)
        console.log(page)
        let items = this.dataTableData
        // console.log(items)

        setTimeout(() => {
          this.loading = false
          resolve(items)
        }, 1000)
      })
    }
  }
}
</script>

<style>
.order-data-table {
  height: 100vh;
  position: fixed;
  bottom: 0;
  width: 100%;
  margin: auto;
}
.v-data-table td {
  font-size: 10px;
  font-weight: bold;
}
.v-chip__content {
  font-size: 10px;
  font-weight: bold;
}
.v-data-table td,
.v-data-table th {
  padding: 0 5px;
}
.v-application .elevation-1 {
  width: 100%;
}
.row {
  width: 100%;
  margin: auto;
}
.elevation-1 .v-chip {
  background: white !important;
}
.rtsFilter {
  font-size: 0.65rem !important;
  background: white !important;
  border-radius: 0px;
  border-right: solid 1px #f1f1f1;
}
</style>
